import { render, staticRenderFns } from "./recover.vue?vue&type=template&id=48cc9200&scoped=true"
import script from "./recover.vue?vue&type=script&lang=js"
export * from "./recover.vue?vue&type=script&lang=js"
import style0 from "./recover.vue?vue&type=style&index=0&id=48cc9200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc9200",
  null
  
)

export default component.exports